module.exports = __webpack_public_path__ + "static/media/title_4.0d560e23.svg";